@if (!isEditing) {
  <div class="content" [ngClass]="{'editable': !readonly}" (click)="enableEditing()">
    @if (!content) {
      <div class="no-content">
        {{placeholder || 'Click to edit...'}}
      </div>
    }
    @if (!!content) {
      <div class="the-content common-content" [innerHTML]="content"></div>
    }
  </div>
}
@if (isEditing) {
  <div class="editor-container">
    @if (editMode === 'visual') {
      <p-editor #contentInput
                styleClass="common-content"
                class="form-input content-edit"
                (onTextChange)="onEditorChange()"
                [(ngModel)]="content"
                [formats]="editorFormats"
                [style]="{ height: visualEditorHeight }">
        @if (useCustomToolbarHeader) {
          <ng-template pTemplate="header">
            <span class="ql-formats">
              <button type="button" class="ql-bold" aria-label="Bold"></button>
              <button type="button" class="ql-italic" aria-label="Italic"></button>
            </span>
            <span class="ql-formats">
              <button type="button" class="ql-list" value="ordered" aria-label="Ordered List"></button>
              <button type="button" class="ql-list" value="bullet" aria-label="Bullet List"></button>
            </span>
            <span class="ql-formats">
              <button type="button" class="ql-clean" aria-label="Remove Formatting"></button>
            </span>
          </ng-template>
        }
      </p-editor>
    }
    @if (editMode === 'html') {
      <code-editor [extensions]="htmlExtensions" [lineWrapping]="true" [(ngModel)]="content" (ngModelChange)="onEditorChange()"></code-editor>
    }
    @if (editMode === 'css') {
      <code-editor [extensions]="cssExtensions" [language]="'css'" [lineWrapping]="true" [(ngModel)]="content" (ngModelChange)="onEditorChange()"></code-editor>
    }
    @if (editMode === 'javascript') {
      <code-editor [extensions]="javascriptExtensions" [language]="'javascript'" [lineWrapping]="true" [(ngModel)]="content" (ngModelChange)="onEditorChange()"></code-editor>
    }
    @if (showModeSwitcher) {
      <div class="mode-switcher">
        @for (mode of supportedEditModes; track mode) {
          @if (editMode !== 'visual' && mode === 'visual') {
            <p-button label="Visual Edit" styleClass="p-button-outlined p-button-sm" (click)="setEditMode('visual')"></p-button>
          }
          @if (editMode !== 'html' && mode === 'html') {
            <p-button label="HTML Edit" styleClass="p-button-outlined p-button-sm" (click)="setEditMode('html')"></p-button>
          }
          @if (editMode !== 'css' && mode === 'css') {
            <p-button label="CSS Edit" styleClass="p-button-outlined p-button-sm" (click)="setEditMode('css')"></p-button>
          }
          @if (editMode !== 'javascript' && mode === 'javascript') {
            <p-button label="JavaScript Edit" styleClass="p-button-outlined p-button-sm" (click)="setEditMode('javascript')"></p-button>
          }
        }
      </div>
    }
  </div>
}
@if (needsSave && isEditing) {
  <div class="actions">
    <p-button type="button" label="Save"  (click)="save()"></p-button>
    <p-button type="button" label="Cancel" styleClass="p-button-text" (click)="cancel()"></p-button>
  </div>
}
